import { Navigate, useLocation } from "react-router-dom";
import useAuthStore from "../../store/authStore";

const PublicRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // If user is authenticated, redirect them to home page or the page they came from
  if (isAuthenticated) {
    return <Navigate to={location.state?.from?.pathname || "/"} replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;